import { render, staticRenderFns } from "./StickerPrinterForm.vue?vue&type=template&id=04513b16&"
import script from "./StickerPrinterForm.vue?vue&type=script&lang=js&"
export * from "./StickerPrinterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports